module.exports = __webpack_public_path__ + "img/self help.5c823ba4.png";